module.exports = __webpack_public_path__ + "media/ALARM.b84fccdc.mp3";